<div class="custom-background">
    <div class="container">
        <div class="row my-5">
            <div class="col-lg-6 col-md-6 col-sm-12 m-auto text-center">
                <a href="/">
                    <img src="./assets/images/logos/logo_bankei.png" class="img-fluid logo" />
                </a>
            </div>
        </div>
        <div class="text-center my-4">

        </div>

        <app-new-alert></app-new-alert>
        <router-outlet></router-outlet>
    </div>
</div>